import {CopilotAnimation, CopilotAnimationType} from '@github-ui/copilot-animation'

export default function CopilotIconAnimation({hidden}: {hidden?: boolean}) {
  return (
    <div aria-hidden={hidden}>
      <CopilotAnimation animationType={CopilotAnimationType.Idle} loopAnimation size={64} />
    </div>
  )
}

try{ CopilotIconAnimation.displayName ||= 'CopilotIconAnimation' } catch {}